/** Pure helpers for the Leaderboards tab — testable without a DOM. */
import type { IconName } from '../../ui/icons';

/** Each board in its own unit: XP a star, Coins a coin, the arena crossed swords. */
export function boardIcon(key: string): IconName {
  return key === 'xp' ? 'star' : key === 'arena' ? 'swords' : 'coin';
}

export type MoveKind = 'up' | 'down' | 'new' | 'same';

/** The movement badge for a row: places since the last hourly update. */
export function moveLabel(moved: number | null): { kind: MoveKind; text: string; title: string } {
  if (moved === null) return { kind: 'new', text: 'NEW', title: 'New on this board since the last update' };
  if (moved > 0) return { kind: 'up', text: `▲${moved}`, title: `Up ${moved} since the last update` };
  if (moved < 0) return { kind: 'down', text: `▼${-moved}`, title: `Down ${-moved} since the last update` };
  return { kind: 'same', text: '–', title: 'No change since the last update' };
}

/** "+1,240" / "−300" for a value change. */
export function fmtGain(n: number): string {
  return n > 0 ? `+${n.toLocaleString()}` : `−${Math.abs(n).toLocaleString()}`;
}

/** 0.2345 → "23%". */
export function winRatePct(r: number): string {
  return `${Math.round(r * 100)}%`;
}

/** ms → "mm:ss" (never negative). */
export function fmtCountdown(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
